module.exports = __webpack_public_path__ + "static/media/logo190.0c834f28.png";